<template>
  <div>
    <div class="container">
      <ais-instant-search :search-client="searchClient" index-name="Airtable">
        <ais-configure
          :distinct="true"
          :analytics="true"
          :enable-personalization.camel="true"
        />
        <div class="search-panel">
          <div class="search-panel__filters">
            <ais-clear-refinements>
              <span slot="resetLabel">Clear refinements</span>
            </ais-clear-refinements>

            <p class="refinement-heading mt-6">Zipcode</p>
            <ais-refinement-list v-model="refinement" searchable attribute="ZIPCODE" />
            <p class="refinement-heading mt-6">Type</p>
            <ais-refinement-list  attribute="TYPE" />
            <p class="refinement-heading mt-6">Rating</p>
            <ais-refinement-list  attribute="RATING" />
            <p class="refinement-heading mt-6">
              Language (in addition to English)
            </p>
            <ais-refinement-list  attribute="LANGUAGE" />
            <p class="refinement-heading mt-6">Accessibility</p>
            <ais-refinement-list  attribute="A11Y" />
            <p class="refinement-heading mt-6">Price</p>
            <ais-refinement-list  attribute="PRICE" />
            <p class="refinement-heading mt-6">Hours</p>
            <ais-refinement-list  attribute="HOURS" />
          </div>

          <div class="search-panel__results">
            <div class="search-header">
              <ais-search-box
                autofocus
                ref="searchBox"
                alt="Search box"
                placeholder="Search here…"
                class="searchbox"
                v-model="searchTerm"
              />
              <ais-voice-search button-title="Voice Search" />
            </div>
            
            <ais-hits>
              <template slot="item" slot-scope="{ item }">
                <div
                
                  class="hits-div"
                  @click="
                    viewedFromSearch({
                      eventName: 'Viewed from Search',
                      index: 'Airtable',
                      objectIDs: [item.objectID],
                    })
                  "
                >
                  <div class="hit-image-wrapper">
                    <img
                      :src="item.IMAGE"
                      :alt="item.TITLE"
                      class="hit-image"
                    />
                  </div>
                  <h1><ais-highlight :hit="item" attribute="TITLE" /></h1>
                  <p><ais-snippet :hit="item" attribute="DESCRIPTION" /></p>
                </div>
              </template>
            </ais-hits>

            <div class="pagination"><ais-pagination :total-pages="3" /></div>
          </div>
        </div>
      </ais-instant-search>
    </div>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch';
import 'instantsearch.css/themes/algolia-min.css';

export default {
  data() {
    return {
      searchTerm: '',
      searchClient: algoliasearch(
        'U7CA3GDTX2',
        'a56c7927f04fc5fda073a4b1ae942ef6'
      ),
      client: null,
      refinement: null,
      index: null,
    };
  },
  mounted() {
    
    // TODO was getting console error aa.default not a function?
    // let userToken = "";
    // algoliasearch.aa("getUserToken", null, (err, algoliaUserToken) => {
    //   if (err) {
    //     console.error(err);
    //     return;
    //   }
    //   userToken = algoliaUserToken;
    // });
    // console.log(userToken);

    setTimeout(() => {
      // axe svg have alternative text
      const searchicons = Array.from(
        document.querySelectorAll('.ais-SearchBox-submitIcon')
      );
      // console.log(searchicons);
      searchicons.forEach((x) => x.setAttribute('aria-label', 'search icon'));

      //
      document.querySelector(
        '.ais-Pagination-item--selected .ais-Pagination-link'
      ).style.backgroundColor = '#104f90';
    }, 3000);
  },
  created() {
    // setTimeout(() => {
    //   this.hideHitsListUntil();
    // }, 500);
  },
  methods: {
    // hideHitsListUntil() {
    //   const hitsList = document.querySelector('.ais-Hits-list');
    //   console.log(hitsList);
    //   hitsList.style.display = 'none';

    //   document.querySelectorAll('.ais-RefinementList-label').forEach((e) => e.addEventListener('click', (e) => {
    //     console.log(e);
    //     hitsList.style.display = 'grid';
    //   }))
    // },
    viewedFromSearch(params) {
      window.aa('viewedFromSearch', params);
      // Retrieves all attributes

      const index = this.searchClient.initIndex('Airtable');
      index.getObject(params.objectIDs[0]).then((object) => {
        this.$router.push({
          path: 'details',
          query: { record: object.RECORD_ID },
        });
        this.$ga.event({
          eventCategory: 'search',
          eventAction: 'route-to-details-page',
          eventLabel: 'from-search-grid'
        })
      });
    },
  },
};
</script>

<style>
body,
h1 {
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
}

.ais-Highlight-highlighted {
  background: cyan;
  font-style: normal;
}

.header {
  display: flex;
  align-items: center;
  min-height: 50px;
  padding: 0.5rem 1rem;
  background-image: linear-gradient(to right, #4dba87, #2f9088);
  color: #fff;
  margin-bottom: 1rem;
}

.header a {
  color: #fff;
  text-decoration: none;
}

.header-title {
  font-size: 1.2rem;
  font-weight: normal;
}

.header-title::after {
  content: ' ▸ ';
  padding: 0 0.5rem;
}

.header-subtitle {
  font-size: 1.2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
}

.search-panel {
  display: flex;
}

.search-panel__filters {
  flex: 1;
  margin-right: 1em;
}

.search-panel__results {
  flex: 3;
}

.searchbox {
  margin-bottom: 2rem;
}

.pagination {
  margin: 2rem auto;
  text-align: center;
}

.hit-image {
  /* max-width: 10.4rem;
  max-height: 7rem; */
  width: 100%;
}

.search-header {
  display: flex;
}

.searchbox {
  flex-basis: 100%;
}

.ais-VoiceSearch-button {
  width: 44px;
  height: 44px;
}

.refinement-heading {
  font-size: 1.25rem;
  font-weight: bold;
}

.ais-Hits-item > p {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ais-Hits-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  grid-gap: 0.75rem;
  /* grid-auto-flow: column;
  grid-auto-columns: minmax(260px, 1fr); */
}

.ais-Hits-item,
.ais-InfiniteHits-item,
.ais-InfiniteResults-item,
.ais-Results-item {
  width: 100%;
  margin: 0;
  padding: 0;
}

.hits-div {
  width: 100%;
  height: 100%;
  padding: 1rem;
  cursor: pointer;
}

@media screen and (max-width: 569px) {
  .search-panel__filters {
    display: none;
  }
}

@media screen and (max-width: 415px) {
  .ais-Hits-list {
    grid-template-columns: 1fr;
  }
  .search-panel__results {
    width: 100%;
    flex: unset;
  }
}
</style>
